import { Server } from '@widgetbot/embed-api'

import controller from '../cerebral'

const api = new Server({ id: controller.state.url.api || 'default' })

api.on('sendMessage', data => {
  if (typeof data === 'string') {
    const channel = controller.state.activeChannel
    controller.signals.sendMessage({ channel, message: data })
  } else if (
    data instanceof Object &&
    typeof data.channel === 'string' &&
    typeof data.message === 'string'
  ) {
    const { channel, message } = data
    controller.signals.sendMessage({ channel, message })
  }
})

export default api

if (window) {
  ;(window as any).api = api
}



// WEBPACK FOOTER //
// ./src/controllers/embed-api/index.ts